"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAsyncState_1 = __importDefault(require("../../hooks/useAsyncState"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const profile_1 = __importDefault(require("../../utils/loader/profile"));
const variables_1 = require("../../variables");
require("./Avatar.css");
const DEFAULT_AVATAR = 'https://decentraland.org/images/male.png';
exports.default = react_1.default.memo(function Avatar({ address, size, src, loading, ...props }) {
    var _a, _b;
    const [failed, setFailed] = (0, react_1.useState)(false);
    const [profile, profileState] = (0, useAsyncState_1.default)(() => profile_1.default.load(address || ''), [address], { callWithTruthyDeps: true });
    const target = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (src) {
            return src;
        }
        else if (failed ||
            !(((_b = (_a = profile === null || profile === void 0 ? void 0 : profile.avatar) === null || _a === void 0 ? void 0 : _a.snapshots) === null || _b === void 0 ? void 0 : _b.face256) || ((_d = (_c = profile === null || profile === void 0 ? void 0 : profile.avatar) === null || _c === void 0 ? void 0 : _c.snapshots) === null || _d === void 0 ? void 0 : _d.face))) {
            return DEFAULT_AVATAR;
        }
        else {
            return (((_f = (_e = profile === null || profile === void 0 ? void 0 : profile.avatar) === null || _e === void 0 ? void 0 : _e.snapshots) === null || _f === void 0 ? void 0 : _f.face256) || ((_h = (_g = profile === null || profile === void 0 ? void 0 : profile.avatar) === null || _g === void 0 ? void 0 : _g.snapshots) === null || _h === void 0 ? void 0 : _h.face));
        }
    }, [profile, failed]);
    return (react_1.default.createElement("img", { loading: "lazy", ...props, src: !loading ? target : undefined, onError: () => setFailed(true), width: (_a = props.width) !== null && _a !== void 0 ? _a : '128', height: (_b = props.height) !== null && _b !== void 0 ? _b : '128', className: TokenList_1.default.join([
            variables_1.StyleNamespace,
            'dcl-avatar',
            `dcl-avatar--${size}`,
            `dcl-avatar--${((address || '')[2] || '').toLowerCase()}`,
            (loading || (!src && profileState.loading)) && `dcl-avatar--loading`,
            props.className,
        ]) }));
});
